import { DateTime } from 'luxon';
import { ListQualityEvent } from '../../types';
import DueColumnV2 from '../DueColumnV2/DueColumnV2';

export const eventLink = (id: number) => `/events/${id}`;

export type DueDateColumnProps = {
  resolvedAt: number | null;
  dueDate?: string | null;
  status: string;
  type: 'task' | 'event';
};
export const renderDueColumn = ({ resolvedAt, status, dueDate, type }: DueDateColumnProps) => {
  const closedAt = resolvedAt ? DateTime.fromSeconds(resolvedAt) : undefined;
  // dueAt returns UNIX timestamp based on UTC so we need to localise it
  if (!dueDate) {
    return <>-</>;
  }
  return (
    <DueColumnV2
      closedAtDatetime={closedAt}
      dueDate={dueDate}
      isInFinalStatuses={
        type === 'event'
          ? ['closed', 'cancelled', 'rejected'].includes(status)
          : ['closed_fail', 'closed_success'].includes(status)
      }
    />
  );
};

export const renderResolvedColumn = (event: ListQualityEvent, localiseDate: (utcDate: string | Date) => Date) => {
  return event.resolved_at ? localiseDate(DateTime.fromSeconds(event.resolved_at).toString()) : undefined;
};
